// Controls all range inputs and applies CSS custom properties for styling
class RangeInputController {
  constructor(settings) {
    this.settings = settings;
    this.initializedInputs = [];
  }

  // Sets up listeners and styles for uninitialized inputs
  bindNew() {
    this.getUninitializedInputs().forEach(input => {
      this.attachInputListener(input);
      this.applyInitialStyles(input);
      this.initializedInputs.push(input);
    });
  }

  // Clears state and reinitializes all matching inputs
  processAll() {
    this.initializedInputs = [];
    this.processUninitialized();
  }

  // Returns range inputs that haven't been processed yet
  getUninitializedInputs() {
    const allInputs = document.querySelectorAll(this.settings.selectors.input);
    return Array.from(allInputs).filter(input => !this.initializedInputs.includes(input));
  }

  // Sets CSS custom property --v to match current value on input event
  attachInputListener(input) {
    input.addEventListener("input", () => {
      input.parentNode.style.setProperty("--v", input.value);
    });
  }

  // Applies initial range styling: min, max, and current value
  applyInitialStyles(input) {
    const parentStyle = input.parentNode.style;
    const computedStyle = getComputedStyle(input.parentNode);

    // Set static range properties
    parentStyle.setProperty("--b", input.min);
    parentStyle.setProperty("--e", input.max);
    parentStyle.setProperty("--dv", input.value); // default value

    // Only set textual labels if they haven't been defined in CSS
    if (!computedStyle.getPropertyValue("--bt")) {
      parentStyle.setProperty("--bt", `"${input.min}"`);
    }
    if (!computedStyle.getPropertyValue("--et")) {
      parentStyle.setProperty("--et", `"${input.max}"`);
    }

    // Trigger input event to initialize --v
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
}

export default RangeInputController;
